<!--
 * @Descripttion: logisticsOrderList--物流订单表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-19 17:14:03
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-12 20:56:21
 -->
<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-button v-if="$btnsPermission('godownEntry:add')" type="primary" @click="handleAdd">创建入库单</el-button>
      <div style="display: flex;margin-top: 12px;">
        <!-- 列表 -->
        <div :style="{ width: isRightShow ? '56%' : '100%' }">
          <el-table ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row border
            @row-click="openDetails">
            <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
              <template slot-scope="{ $index }">
                {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="inCode" min-width="120px" label="单据编号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="inType" min-width="120px" label="单据类型">
              <template slot-scope="scope">
                <dict-tag :options="dictObj.inType" :value="scope.row.inType" />
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip prop="applyOrgName" min-width="120px" label="申请部门">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="inWay" width="150px" label="入库方式">
              <template slot-scope="scope">
                <dict-tag :options="dictObj.warehouseType" :value="scope.row.inWay" />
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip prop="state" width="95px" label="订单状态">
              <template slot-scope="scope">
                <dict-tag :options="dictObj.warehouseOrderStatus" :value="scope.row.state" />
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="inType" width="160px" label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.createTime ? parseTime(scope.row.createTime) : null }}
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
            :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
        </div>
        <!-- 详情 -->
        <div v-if="isRightShow" class="detail" :style="{ maxHeight: heightStyleObj }">
          <div class="detail-top">
            <div style="font-size: 15px;">
              <div style="margin-bottom: 8px;">{{ crrData.inCode }}</div>
              <dict-tag :options="dictObj.warehouseOrderStatus" :value="crrData.state" />
            </div>
            <div>
              <el-button v-if="crrData.state === 'DSH' && $btnsPermission('warehouse:sh')" type="primary" class="common-btn" @click="handleAudit">审核订单
              </el-button>
              <el-button v-if="crrData.state === 'DCL' && $btnsPermission('warehouse:xkdd')" type="primary" class="common-btn" @click="handleEdit">修改订单
              </el-button>
              <el-button v-if="gbddShow && $btnsPermission('warehouse:gbdd')" type="primary" class="common-btn" @click="hanldClose">关闭订单
              </el-button>
              <el-button v-if="crrData.state === 'DSH' && $btnsPermission('warehouse:qx')" type="primary" class="common-btn" @click="handleAuditClose">关闭订单
              </el-button>
            </div>
          </div>
          <el-tabs v-model="activeNameForDeatil" type="border-card" @before-leave="detailsTabs"
            @tab-click="handleClickForDeatil">
            <el-tab-pane label="单据信息" name="infomation">
              <infomation v-if="activeNameForDeatil === 'infomation'" ref="infomation" :info="crrData" :dict-obj="dictObj"
                @changeParentLoading="changeParentLoading">
              </infomation>
            </el-tab-pane>
            <el-tab-pane label="产品列表" name="productList">
              <productList v-if="activeNameForDeatil === 'productList'" ref="productList" :info="crrData"
                :dict-obj="dictObj" @changeParentLoading="changeParentLoading">
              </productList>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="cell_btn"><a class="zk_btn" @click="handleToggle"><i
              :class="isRightShow ? 'el-icon-caret-right' : 'el-icon-caret-left'"></i></a></div>

      </div>
    </el-card>
    <addOrder v-if="addShow" :visible="addShow" :order-info="orderInfo" :dict-obj="dictObj" @close="closeAdd"></addOrder>
  </div>
</template>

<script>
import { getDict } from '@/api/common'
import { closeWarehousingOrder, getWareHousingOrder, productionCancel } from "@/api/warehousingOrder";
import infomation from './components/infomation' // 单据信息
import addOrder from './components/addOrder'
import productList from './components/productList.vue'
export default {
  components: {
    infomation,
    addOrder,
    productList
  },
  data() {
    return {

      heightStyleObj: '',
      loading: true, // 遮罩
      isRightShow: true,
      detailsTabs: true,
      addShow: false, // 新增入库单
      activeNameForDeatil: '',
      crrData: {}, // 当前选中的物流订单信息
      orderInfo: {},
      pageListData: [], // 列表数据
      queryItems: [
        {
          label: '关键字',
          field: 'inCode',
          placeholder: '单据编号',
          type: 'input'
        },
        {
          label: '单据类型',
          field: 'inType',
          type: 'select',
          options: []
        },
        {
          label: '入库方式',
          field: 'inWay',
          type: 'select',
          options: []
        },
        {
          label: '订单状态',
          field: 'state',
          type: 'select',
          options: []
        }
      ],
      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      dictObj: {
        warehouseOrderStatus: [],
        warehouseType: [],
        bizType: [],
        inType: [],
        receiptDeliveryState: [],
      },
    }
  },

  computed: {
    // 关闭订单按钮
    gbddShow() {
      const orderStatusWhiteList = ['JXZ', 'DCL']
      const orderStatusExitsFlag = orderStatusWhiteList.includes(this.crrData.state)
      return orderStatusExitsFlag
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getPageListData()
    this.getDicts(['warehouseOrderStatus', 'warehouseType', 'bizType', 'inType', 'receiptDeliveryState'])
  },
  methods: {
    handleAuditClose() {
      this.$confirm(`确定取消入库？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true // 打开遮罩
        productionCancel(this.crrData.id).then(() => {
          this.getPageListData() // 重新加载数据列表
        }).finally(() => {
          this.loading = false // 关闭遮罩
        })
      })
        .catch(() => { })
    },
    handleAudit() {
      this.orderInfo = JSON.parse(JSON.stringify(this.crrData))
      this.addShow = true
    },
    handleAdd() {
      this.orderInfo = {}
      this.addShow = true
    },
    handleEdit() {
      this.orderInfo = JSON.parse(JSON.stringify(this.crrData))
      this.orderInfo.inWay = 'manualEntry'
      this.addShow = true
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          if (dictType === 'inType') {
            const findIndex = this.queryItems.findIndex(item => item.field === dictType)
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
          if (dictType === 'warehouseType') {
            const findIndex = this.queryItems.findIndex(item => item.field === 'inWay')
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
          if (dictType === 'warehouseOrderStatus') {
            const findIndex = this.queryItems.findIndex(item => item.field === 'state')
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },
    // 关闭新增弹窗
    closeAdd() {
      this.addShow = false;
      this.getPageListData()
    },
    //关闭订单
    hanldClose() {
      this.$confirm(`确定关闭订单？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true // 打开遮罩
        closeWarehousingOrder({ id: this.crrData.id }).then(() => {
          this.getPageListData() // 重新加载数据列表
        }).finally(() => {
          this.loading = false // 关闭遮罩
        })
      })
        .catch(() => { })
    },
    openDetails(row) {
      this.crrData = row
      this.isRightShow = true
      this.activeNameForDeatil = 'productList' // 将商品列表tab选中
      this.$nextTick(() => {
        this.$refs.productList.open(this.crrData)
      })
    },
    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const { id } = this.crrData
      const params = JSON.parse(JSON.stringify(this.searchParam))
      getWareHousingOrder(params).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
        this.crrData = this.pageListData.find(item => item.id === id) ? this.pageListData.find(item => item.id === id) : this.pageListData[0]
        if (this.crrData) {
          this.activeNameForDeatil = 'productList' // 将商品列表tab选中
          this.detailsTabs = true
          this.isRightShow = true
          // 将行设置选中状态
          this.$refs.dataTable.setCurrentRow(this.crrData)
          this.$nextTick(() => {
            this.$refs.productList.open(this.crrData)
          })
        } else {
          this.isRightShow = false
          this.crrData = {}
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 副tabs 切换
    handleClickForDeatil(data) {
      this.activeNameForDeatil = data.name // 将现在选中的值赋给用于判断的
      this.$nextTick(() => {
        this.$refs[data.name].open(this.crrData)
      })
    },
    // 处理显示与隐藏
    handleToggle() {
      this.isRightShow = !this.isRightShow
      if (this.isRightShow) {
        this.handleClickForDeatil({ name: 'productList' })
      }
    },
    changeParentLoading(flag) {
      this.loading = flag
    }
  }
}
</script>

<style lang="scss" scoped >
.detail {
  width: 43%;
  margin: 0 12px;
  border: 1px solid #D7D7D7;
  overflow-y: auto;

  /* 让padding-right不会影响内容宽度 */
  .detail-top {
    background-color: rgb(244, 246, 249);
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* 定义滚动条的轨道部分 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

/* 定义滚动条的thumb部分 */
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
  background: rgba(0, 0, 0, .2);
}
</style>
